import React, { useCallback, useState } from 'react';
import { Stack, Box, IconButton, Tooltip } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import User, { Company } from '../../../interfaces/users.interface';
import { DataCell, DataRow, DataRowActions } from '../../Tables/DataList';
import { tightTableSx } from '../../Tables/dataTableStyles';
import { getCompanyPendingUsers } from '../../../services/companyDetail';
import { useCompanyResource } from '../../Vendors/useCompanyResource';
import { TabEmpty, TabPagination, TabSkeletonRows } from '../../Vendors/companyTabUi';

const PAGE_SIZE = 5;

type PendingUsersTabProps = {
  company: Company;
  companyCallback: any;
};

export default function PendingUsersTab(props: PendingUsersTabProps) {
  const { company } = props;
  const [page, setPage] = useState(1);
  const { items: pendingUsers, count, loading } = useCompanyResource<User>(
    getCompanyPendingUsers,
    company.id,
    page,
    PAGE_SIZE,
  );

  const handleResendInvite = useCallback((userId: number) => {
    // Mock resend - in production this would call an API
    console.log(`Resending invite to user ${userId}`);
  }, []);

  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      <Box sx={tightTableSx}>
        <DataRow header>
          <DataCell xs={3}>Name</DataCell>
          <DataCell xs={3}>Email</DataCell>
          <DataCell xs={3}>Invited Date</DataCell>
          <DataCell xs={3}>&nbsp;</DataCell>
        </DataRow>

        {loading && <TabSkeletonRows rows={3} columns={[3, 3, 3, 3]} />}

        {!loading && pendingUsers.length === 0 && <TabEmpty label='No pending users' />}

        {!loading && pendingUsers.map((user) => (
          <DataRow key={user.id} onClick={() => {}} hover>
            <DataCell xs={3}>{user.firstName} {user.lastName}</DataCell>
            <DataCell xs={3}>{user.email}</DataCell>
            <DataCell xs={3}>Pending</DataCell>
            <DataCell xs={3}>
              <DataRowActions>
                <Tooltip title="Resend Invite">
                  <IconButton size='small' onClick={() => handleResendInvite(user.id!)}>
                    <MailOutlineIcon />
                  </IconButton>
                </Tooltip>
              </DataRowActions>
            </DataCell>
          </DataRow>
        ))}
      </Box>

      <TabPagination count={count} page={page} pageSize={PAGE_SIZE} onChange={setPage} />
    </Stack>
  );
}
